/* eslint-disable react/no-array-index-key */
import React from 'react';
import { HealthCareFilter } from '../../Components/Forms';
import { SectionHeading } from '../../Components/SectionHeading';
import { RightArrow } from '../../Components/icons';
import { AnchorLink, RoundButton } from '../../Components/button';
import { SimpleSlider } from '../../Components/sliders';
import ProfileCard from '../../Components/Card/ProfileCard/profileCard';
import MonitorHealthSection from './monitorHealthSection/MonitorHealthSection';
import HealthConditions from './healthConditions/HealthConditions';
import DiscoverWellnesstopics from './discoverWellnessTopics/DiscoverWellnesstopics';
import BloodPressureMonitor from './bloodPressureMonitor/BloodPressureMonitor';
import RecomendedDoc from './recomendedDoc/RecomendedDoc';
import ExploreMoreHealthConditions from './exploreHealthMoreConditions/ExploreMoreHealthConditions';
import TypingAnimation from '../../Components/typingAnimation/TypingAnimation';
import MainBanner from '../../Components/mainBannerComponent/MainBanner';
import TopReads from './topReads/TopReads';
import Layouts from '../../layouts/Layouts';
import img from '../../assets/images/svg/doc.svg';

const cardsData = [
  {
    image: img,
    name: 'ڈاکٹر مدیحہ اسد',
    proff: 'گائناکالوجسٹ، پرسوتی ماہر',
    edu: 'MBBS، FCPS (گائنی اور پرسوتی)',
    exp: 'تجربہ: 20+ سال'
  },
  {
    image: img,
    name: 'ڈاکٹر مدیحہ اسد',
    proff: 'گائناکالوجسٹ، پرسوتی ماہر',
    edu: 'MBBS، FCPS (گائنی اور پرسوتی)',
    exp: 'تجربہ: 20+ سال'
  },
  {
    image: img,
    name: 'ڈاکٹر مدیحہ اسد',
    proff: 'گائناکالوجسٹ، پرسوتی ماہر',
    edu: 'MBBS، FCPS (گائنی اور پرسوتی)',
    exp: 'تجربہ: 20+ سال'
  },
  {
    image: img,
    name: 'ڈاکٹر مدیحہ اسد',
    proff: 'گائناکالوجسٹ، پرسوتی ماہر',
    edu: 'MBBS، FCPS (گائنی اور پرسوتی)',
    exp: 'تجربہ: 20+ سال'
  }
];

const btnTitle = [
  'گردوں کی پتری',
  'الرجی',
  'ذہنی دباؤ',
  'بال گرنا',
  'ویکسینز',
  'گردوں کی پتری',
  'الرجی',
  'ذہنی دباؤ',
  'بال گرنا',
  'ویکسینز'
];
function HomePageUrdu() {
  const buttons = btnTitle.map((button, index) => (
    <RoundButton text={button} key={index} />
  ));

  const items = cardsData.map((card, index) => (
    <ProfileCard card={card} key={index + 1} />
  ));

  return (
    <Layouts>
      <section className="homepage mainBannerPage urdu">
        <MainBanner />
        <SectionHeading
          heading="بہترین تلاش کریں۔
          "
          colorHeading={<TypingAnimation />}
          icon={<RightArrow />}
          link={<AnchorLink to="/" text="براؤز کریں۔" />}
        />
        <HealthCareFilter />
        <SimpleSlider
          className="profileSlider"
          sliderTitle="سر فہرست جنرل فزیشنز"
        >
          {items}
        </SimpleSlider>
        <MonitorHealthSection />
        <HealthConditions />
        <SimpleSlider
          sliderTitle="موضوعات کو دریافت کریں۔
"
        >
          {buttons}
        </SimpleSlider>
        <DiscoverWellnesstopics />
        <BloodPressureMonitor />
        <TopReads />
        <ExploreMoreHealthConditions />
        <RecomendedDoc />
      </section>
    </Layouts>
  );
}

export default HomePageUrdu;
